import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { ThreeDots, XLg } from "react-bootstrap-icons";
import { ClockHistory } from "react-bootstrap-icons";
import { List } from "react-bootstrap-icons";

export const HeaderContainer = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  background-color: ${({ theme }) => theme.neutralBackgroundMedium};
  justify-content: space-between;
  z-index: 1000;
`;

export const Header = styled.div`
  height: 64px;
`;

export const VerticalSeparator = styled.div<{
  $right?: number;
  $left?: number;
}>`
  border-left: 1px solid ${({ theme }) => theme.neutralBorder};
  height: 64px;
  position: relative;
  align-self: center;
  padding-left: 16px;
  ${({ $right }) => ($right ? "right:" + $right + "px" : "")}
  ${({ $left }) => ($left ? "left:" + $left + "px" : "")}
`;

export const ProjectTitleBlock = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ProjectNameBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubmenuBlock = styled.div`
  margin-top: 5px;
  margin-left: 10px;
`;

export const ProjectSettingsBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ProjectTitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  position: relative;
`;

export const LinkContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
  padding-left: 20px;
  text-align: center;
`;

export const NavLinkButton = styled(NavLink)`
  display: inline-grid;
  height: 40px;
  justify-items: center;
  align-content: center;
  position: relative;
  cursor: pointer;
  color: ${({ theme }) => theme.neutralTextWeak};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  padding: 0 12px;
  &.active {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.neutralBackgroundBase};
    color: ${({ theme }) => theme.primaryText};
    border-radius: 5px;

    &:after {
      content: "";
      height: 2px;
      border-radius: 5px;
      width: 100%;
      margin-top: 62px;
      background: ${({ theme }) => theme.primaryBorder};
      position: absolute;
    }
  }
  &:hover {
    background-color: ${({ theme }) => theme.neutralBackgroundHover};
    border-radius: 5px;
    color: ${({ theme }) => theme.neutralText};
  }
`;

export const ProjectNameTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.neutralText};
`;

export const ProjectPopulation = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${({ theme }) => theme.neutralTextWeak};
`;

export const ProjectTitleAction = styled(ThreeDots)`
  align-self: center;
  cursor: pointer;
  filter: invert(39%) sepia(9%) saturate(571%) hue-rotate(178deg)
    brightness(94%) contrast(89%);
`;

export const ClockIcon = styled(ClockHistory)`
  width: 16px;
  fill: #5f6877;
  height: 16px;
`;


export const HamburgerMenu = styled.div`
  position: absolute;
  z-index:10px;
  left: 0;
  top: 64px;
  display: flex;
  background-color: ${({theme}) => theme.neutralBackgroundBase};
  margin-right: 10px;
  flex-direction: column;
  padding: 8px 0;
  border: 1px solid ${({theme}) => theme.neutralBorder};
`

export const HamburgerMenuItem = styled.a<{$active?: boolean}>`
  width: 232px;
  user-select: none;
  display: flex;
  gap: 4px;
  padding: 4px 12px;
  color: ${({theme}) => theme.neutralTextWeak};
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  transition: 0.3s;
  cursor: pointer;
  &:hover {
    font-weight: 600;
    color: ${({theme}) => theme.neutralText};
  }

  ${({$active, theme}) => $active && `
    color: ${theme.neutralText};
    font-weight: 600;
    ${HamburgerMenuWrapper} {
      
    }
  `}

  .icon {
    width: 32px;
    height: 32px;
    margin: 0;
  }

  svg {
    margin-left: auto;
    width: 16px;
    height: 16px;
  }
`

export const HamburgerMenuWrapper = styled.div<{$isOpen?: boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 60px;
  cursor: pointer;
  position: relative;
  align-items: center;
  transition: 0.3s;
  /* padding-right: 20px; */
  /* padding: 20px; */

  svg {
    color: ${({theme}) => theme.neutralTextWeak};
    cursor: pointer;
    z-index: 1;
    width: 20px;
    height: 20px;
  }

  &:hover {
    background-color: #5F68771F;
  }
  &:active {
    background-color: #5F687729;
  }

  ${({$isOpen,theme}) => $isOpen && `
    background-color: ${theme.neutralBackgroundMedium} !important;
  `}
`

export const IconWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Hamburger = styled(List)`
  color: ${({theme}) => theme.neutralTextWeak};
  &:hover {
    color: ${({theme}) => theme.neutralText};
  }
`;
export const HamburgerCloseIcon = styled(XLg)`
  color: ${({theme}) => theme.neutralTextWeak};
  &:hover {
    color: ${({theme}) => theme.neutralText};
  }
`;

export const RightWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const Comments = styled.div`
  position: relative;
  display: flex;
`

export const Icon = styled.button<{
  $disableBackground?: boolean;
  $color?: string;
  $showAlert: boolean;
}>`
  display: flex;
  align-self: center;
  border: none;
  border-radius: 5px;
  width: 36px;
  height: 36px;
  transition: 0.3s linear;
  background: ${({ theme, $disableBackground, $showAlert }) =>
    $disableBackground
      ? "transparent"
      : $showAlert
        ? theme.primaryBackgroundActive
        : theme.primaryBackground};
  color: ${({ theme, $color }) => ($color ? theme[$color] : theme.primaryText)};
  justify-content: center;
  place-items: center;
  cursor: pointer;
  position: relative;
  margin-right: ${({ $color }) => ($color ? "15px" : "")};

  svg {
    width: 14px;
    height: 16px;
    position: absolute;
  }
`;

export const MenuWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const NotificationAlert = styled.div<{ $active?: boolean }>`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.primaryAction};
  right: -5px;
  bottom: -5px;
  position: absolute;
  padding: 1px 3px;
  border-radius: 4px;
  border: 1px solid #fff;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  min-height: 16px;
  min-width: 16px;
  /* line-height: 14px; */
  color: ${({ theme }) => theme.primaryTextStrong};
  transition: 0.3s linear;
  ${({ $active }) => ($active ? `opacity: 1` : `opacity: 0`)}
`;

export const HeadingMenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
`;

export const ProjectNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
  z-index: 3;
`;

export const Status = styled.div<{ $size: number }>`
  font-size: ${({ $size }) => `${$size}px `};
  color: ${({ theme }) => theme.successText};
  border: 1px solid ${({ theme }) => theme.successBackgroundMedium};
  justify-content: center;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.successBackground};
  align-self: center;
  margin: 0 4px;
  border-radius: 2px;
  font-weight: 400;
`;

export const StatusTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 0 4px;
  font-size: 12px;
  height: 20px;
`;

export const RightBlock = styled.div`
  display: flex;
  border-left: ${({ theme }) => `1px solid ${theme.successBackground}`};
  padding: 20px;
`;

export const LeftBlock = styled.div<{ $isPublic?: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px ${({ $isPublic }) => $isPublic ? '20px' : '12px'} 20px ${({ $isPublic }) => $isPublic ? '20px' : '0'};
`;

export const LinkBox = styled.div`
  display: flex;
`;
